import { 
    SPECIALTY_BEGIN,
    SPECIALTY_ADD,
    SPECIALTY_FAILURE,
    SPECIALTY_CLEAR,

    SPECIALTY_FILTER_BEGIN,
    SPECIALTY_FILTER_SUCCESS,
    SPECIALTY_FILTER_FAILURE,
    SPECIALTY_FILTER_CLEAR

} from 'app/actions/SpecialtyActions';

const initialState = {
	byId: {},
    allIds: [],
    filterData: [],
	isLoading: false,
};

export default function SpecialtyReducer (state = initialState, action) {
	switch (action.type) {
        case SPECIALTY_BEGIN: 
			return {
				...state,
				isLoading: true
			}
        case SPECIALTY_ADD:
			let allIds =action.payload.data.Data;

			return {
				...state,
				allIds,
				isLoading: false,
            };
        case SPECIALTY_CLEAR:
            return {
                ...state,
                allIds: [],
                isLoading: false,
            }
        case SPECIALTY_FAILURE: 
			return {
				...state,
				isLoading: false
            }
        case SPECIALTY_FILTER_BEGIN:
            return {
                ...state,
                isLoading: true
            }
        case SPECIALTY_FILTER_SUCCESS:
            let filterData = [...new Set(state.filterData.concat(action.payload.filterData))];
            return {
                ...state,
                filterData,
                isLoading: false,
            };
        case SPECIALTY_FILTER_CLEAR:
            return {
                ...state,
                filterData: [],
                isLoading: false,
            }
        case SPECIALTY_FILTER_FAILURE:
            return {
                ...state,
                isLoading: false
            }
		default:
			return state;
	}
};

export const getSpecialty = state => {
	return state.allIds;
}

export const getIsLoadingSpecialty = state => {
    return state.isLoading;
}

export const getSpecialtyFilter = state => {
    return state.filterData
}
export const getIsLoadingSpecialtyFilter = state => {
    return state.isLoading;
}